import React, { Component } from 'react'
import { Section } from '../../components'
import { LinkHaveAccountStyled } from './styled'
import { ROUTE_PATH } from '../../helpers'

export class LinkHaveAccountContainer extends Component {
  constructor(props) {
    super(props)

    this.state = {
      redirect: false,
    }
  }

  componentDidMount() {
    setTimeout(() => {
      this.props.history.push(ROUTE_PATH.LOGIN.LINK)
    }, 5000)
  }

  render() {
    return (
      <React.Fragment>
        <LinkHaveAccountStyled className="activate-page">
          <Section className="activate-wrapper">
            <Section className="notification">
              <p>You already have an account</p>
            </Section>
          </Section>
        </LinkHaveAccountStyled>
      </React.Fragment>
    )
  }
}
